export { DURACAO_MAX_DIGITOS } from "../hooks/nova-obra.duracao";

export const MENU_PERIODOS_BUSCA = "Buscar período";

export const MENU_PERIODOS_VAZIO = "Nenhum período encontrado.";
